<template>
  <b-tabs
    v-model="tabIndex"
    content-class="mt-1"
  >
    <!-- Tab de listado -->
    <b-tab
      title="Listado de listas de precios"
      lazy
    >
      <price-lists-list
        @addPriceListTab="newTab($event)"
        @editPriceListTab="editTab($event)"
      />
    </b-tab>

    <!-- Tabs de vista de detalles -->
    <b-tab
      v-for="priceList in priceListsTabs"
      :key="priceList.id"
      :title="'Lista #' + priceList.id"
      lazy
    >
      <price-list-detail
        :price-list-id="priceList.id"
        @closeTab="closeTab(priceList.id)"
      />
    </b-tab>

    <!-- Botón para cerrar tab -->
    <template
      v-if="priceListsTabs.length > 0"
      #tabs-end
    >
      <b-nav-item
        @click.prevent="closeTab(priceListsTabs[0].id)"
      >
        <b>x</b>
      </b-nav-item>
    </template>

  </b-tabs>
</template>

<script>
import PriceListsList from './PriceListsList.vue'
import PriceListDetail from './PriceListDetail.vue'

export default {
  components: {
    PriceListsList,
    PriceListDetail,
  },

  data() {
    return {
      tabIndex: 0,
      priceListsTabs: [],
    }
  },

  watch: {
    '$route.params.id': function routeParamsIdWatcher(newId) {
      if (newId) {
        this.newTab(Number(newId))
      }
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.newTab(Number(this.$route.params.id))
    }
  },

  methods: {
    newTab(priceListId) {
      // Verificar si ya existe una tab abierta para este ID
      const existingTab = this.priceListsTabs.find(tab => tab.id === priceListId)
      if (!existingTab) {
        this.priceListsTabs.push({
          id: priceListId,
        })
      }
      setTimeout(() => {
        this.tabIndex = this.priceListsTabs.length
      }, 100)
    },

    editTab(priceListId) {
      // Simplemente abrir la vista del detalle, la edición se maneja con sidebar
      this.newTab(priceListId)
    },

    closeTab(priceListId) {
      for (let i = 0; i < this.priceListsTabs.length; i += 1) {
        if (this.priceListsTabs[i].id === priceListId) {
          this.priceListsTabs.splice(i, 1)
          break
        }
      }
      this.tabIndex = 0 // Redirigir al listado
    },
  },
}
</script>
